export const SETTINGS_UPDATE = 'SETTINGS_UPDATE'
export const WALLET_UPDATE = 'WALLET_UPDATE'
export const BONUS_ACTIVATE = 'BONUS_ACTIVATE'
export const BONUS_DEACTIVATE = 'BONUS_DEACTIVATE'
export const BONUS_STATUS = 'BONUS_STATUS'
export const BONUS_ELIGIBLE = 'BONUS_ELIGIBLE'

export const PREFERENCES_UPDATE = 'PREFERENCES_UPDATE'
export const CONNECTION_UPDATE = 'CONNECTION_UPDATE'

export const ACCOUNT_VERIFICATION_UPDATE = 'ACCOUNT_VERIFICATION_UPDATE'
export const ACCOUNT_UPDATE = 'ACCOUNT_UPDATE'
export const ACCOUNT_LOGOUT = 'ACCOUNT_LOGOUT'
export const ACCOUNT_AUTHORIZED = 'ACCOUNT_AUTHORIZED'
export const ACCOUNT_RESOLVING = 'ACCOUNT_RESOLVING'
export const BETS_COUNT_UPDATE = 'BETS_COUNT_UPDATE'

export const BESPOKE_MARKET_UPDATE = 'BESPOKE_MARKET_UPDATE'
export const BESPOKE_MARKETS_STATE_UPDATE = 'BESPOKE_MARKETS_STATE_UPDATE'

/*
  Sportsbook state updates
*/
export const SPORTSBOOK_STATE_UPDATE = 'SPORTSBOOK_STATE_UPDATE'
export const SPORTSBOOK_SPORT_ADD = 'SPORTSBOOK_SPORT_ADD'
export const SPORTSBOOK_SPORT_REMOVE = 'SPORTSBOOK_SPORT_REMOVE'
export const SPORTSBOOK_SPORT_UPDATE = 'SPORTSBOOK_SPORT_UPDATE'
export const SPORTSBOOK_SERVICES_UPDATE = 'SPORTSBOOK_SERVICES_UPDATE'
export const SPORTSBOOK_PATH_UPDATE = 'SPORTSBOOK_PATH_UPDATE'

/*
  Sport state actions
*/
export const SPORT_STATE_UPDATE = 'SPORT_STATE_UPDATE'
export const SPORT_CATEGORY_ADD = 'SPORT_CATEGORY_ADD'
export const SPORT_CATEGORY_REMOVE = 'SPORT_CATEGORY_REMOVE'
export const SPORT_CATEGORY_UPDATE = 'SPORT_CATEGORY_UPDATE'

/*
  Category state actions
*/
export const CATEGORY_STATE_UPDATE = 'CATEGORY_STATE_UPDATE'
export const CATEGORY_TOURNAMENT_ADD = 'CATEGORY_TOURNAMENT_ADD'
export const CATEGORY_TOURNAMENT_REMOVE = 'CATEGORY_TOURNAMENT_REMOVE'
export const CATEGORY_TOURNAMENT_UPDATE = 'CATEGORY_TOURNAMENT_UPDATE'

/*
  Tournament state actions
*/
export const TOURNAMENT_STATE_UPDATE = 'TOURNAMENT_STATE_UPDATE'
export const TOURNAMENT_EVENT_ADD = 'TOURNAMENT_EVENT_ADD'
export const TOURNAMENT_EVENT_REMOVE = 'TOURNAMENT_EVENT_REMOVE'

/*
  Event state actions
*/
export const EVENT_STATE_UPDATE = 'EVENT_STATE_UPDATE'
export const EVENT_MARKET_TYPE_UPDATE = 'EVENT_MARKET_TYPE_UPDATE'
export const EVENT_ODDS_UPDATE = 'EVENT_ODDS_UPDATE'
export const EVENT_SCORE_UPDATE = 'EVENT_SCORE_UPDATE'
export const EVENT_MARKET_STATUS_UPDATES = 'EVENT_MARKET_STATUS_UPDATES'
export const EVENT_OUTCOME_STATUS_UPDATES = 'EVENT_OUTCOME_STATUS_UPDATES'
export const EVENT_SET = 'EVENT_SET'
export const EVENT_MARKET_SUSPENSION_UPDATE = 'EVENT_MARKET_SUSPENSION_UPDATE'
export const EVENT_MARKET_VISIBILITY_UPDATE = 'EVENT_MARKET_VISIBILITY_UPDATE'

/*
  Casino state actions
*/
export const CASINO_GAME_STATE_UPDATE = 'UPDATE_CASINO_GAME_STATE'
export const CASINO_STATE_UPDATE = 'CASINO_STATE_UPDATE'
export const CASINO_LAST_STATE_UPDATE = 'CASINO_LAST_STATE_UPDATE'
export const CASINO_GAME_ADD = 'CASINO_GAME_ADD'
export const CASINO_FAVORITES_ADD = 'CASINO_FAVORITES_ADD'
export const CASINO_GAME_UPDATE = 'CASINO_GAME_UPDATE'
export const CASINO_FAVORITE_GAME_UPDATE = 'CASINO_FAVORITE_GAME_UPDATE'
export const CASINO_STATE_TOGGLE = 'CASINO_STATE_TOGGLE'

/*
  Documents state actions
*/
export const DOCUMENTS_STATE_UPDATE = 'DOCUMENTS_STATE_UPDATE'

/*
  Layout state actions
*/
export const CMS_CONFIG_LOADED = 'CMS_CONFIG_LOADED'

/*
  Betslip actions
*/
export const BETSLIP_STATE_UPDATE = 'BETSLIP_STATE_UPDATE'
export const BETSLIP_ADD_BET = 'BETSLIP_ADD_BET'
export const BETSLIP_SELECT_BET = 'BETSLIP_SELECT_BET'
export const BETSLIP_REPLACE_BET = 'BETSLIP_REPLACE_BET'
export const BETSLIP_REMOVE_BET = 'BETSLIP_REMOVE_BET'
export const BETSLIP_REMOVE_BET_NOW = 'BETSLIP_REMOVE_BET_NOW'
export const BETSLIP_UPDATE_BET = 'BETSLIP_UPDATE_BET'
export const BETSLIP_UPDATE_BETS = 'BETSLIP_UPDATE_BETS'
export const BETSLIP_CLEAR_BETS = 'BETSLIP_CLEAR_BETS'
export const BETSLIP_CLEAR_BETS_OR_BET_NOW = 'BETSLIP_CLEAR_BETS_OR_BET_NOW'
export const BETSLIP_UPDATE_BET_TYPE = 'BETSLIP_UPDATE_BET_TYPE'
export const BETSLIP_ADD_REPORT = 'BETSLIP_ADD_REPORT'
export const BETSLIP_REMOVE_REPORT = 'BETSLIP_REMOVE_REPORT'
export const BETSLIP_UPDATE_REPORTS = 'BETSLIP_UPDATE_REPORTS'
export const BETSLIP_CLEAR_REPORTS = 'BETSLIP_CLEAR_REPORTS'
export const BETSLIP_UPDATE_ERRORS = 'BETSLIP_UPDATE_ERRORS'
export const BETSLIP_CLEAR_ERROR = 'BETSLIP_CLEAR_ERROR'
export const BETSLIP_SETTINGS_UPDATE = 'BETSLIP_SETTINGS_UPDATE'

export const BET_ITEM_STATE_UPDATE = 'BET_ITEM_STATE_UPDATE'
export const BET_ITEM_OUTCOME_REPLACE = 'BET_ITEM_OUTCOME_REPLACE'
export const BET_TYPE_STATE_UPDATE = 'BET_TYPE_STATE_UPDATE'

/*
  Layout actions
*/
export const SET_LAYOUT = 'SET_LAYOUT'
export const SET_MOBILE_DEVICE = 'SET_MOBILE_DEVICE'
export const SET_SIDEBAR_LEFT = 'SET_SIDEBAR_LEFT'
export const SET_SIDEBAR_RIGHT = 'SET_SIDEBAR_RIGHT'
export const SET_MAIN_MENU = 'SET_MAIN_MENU'
export const SET_LIVE_CHAT = 'SET_LIVE_CHAT'

export const SET_BETSLIP_MODE = 'SET_BETSLIP_MODE'
export const SET_BETSLIP = 'SET_BETSLIP'
